import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { getTextColorsFromSection } from '../../lib/colors';
import mapBy from '../../lib/mapBy';
import Section from '../../Section';
import Typography from '../../Typography';
import PreOrderItem from './PreOrderItem';
import CouponContainer from '../Coupon';
import OrderSummary from '../OrderSummary';

class PreOrderForm extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    site: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    ticketsCount: PropTypes.number.isRequired,
    subtotalValue: PropTypes.number.isRequired,
    totalValue: PropTypes.number.isRequired,
    ticketTypes: PropTypes.array,
    coupon: PropTypes.object,
  };

  static defaultProps = {
    coupon: null,
    ticketTypes: null,
  };

  static compareByCreatedAt(a, b) {
    return Date.parse(a.createdAt) - Date.parse(b.createdAt);
  }

  ticketBenefitMapper = ticketType => {
    const { coupon } = this.props;
    if (coupon) {
      if (
        coupon.type === 'access' &&
        !ticketType.active &&
        coupon.ticketTypeIds.includes(ticketType.id)
      ) {
        return { ...ticketType, benefit: 'access' };
      }

      if (typeof ticketType.salePrice === 'number') {
        return { ...ticketType, benefit: 'discount' };
      }
    }

    return ticketType;
  };

  compareByCouponAndDate = (a, b) => {
    switch (a.benefit) {
      case 'access': {
        return b.benefit === 'access' ? PreOrderForm.compareByCreatedAt(a, b) : -1;
      }
      case 'discount': {
        if (b.benefit === 'access') {
          return 1;
        }
        return b.benefit === 'discount' ? PreOrderForm.compareByCreatedAt(a, b) : -1;
      }
      case 'none':
      default:
        return typeof b.benefit === 'string' ? 1 : PreOrderForm.compareByCreatedAt(a, b);
    }
  };

  render() {
    const {
      classes,
      event,
      site,
      section,
      ticketTypes,
      ticketsCount,
      subtotalValue,
      totalValue,
      handleSubmit,
      submitting,
      coupon,
    } = this.props;
    const colors = getTextColorsFromSection(site, section);
    let child;

    if (!ticketTypes) {
      child = (
        <Typography className={classes.emptyContent}>
          <FormattedMessage id="loadingTicketTypes" />
        </Typography>
      );
    } else if (!ticketTypes.length) {
      child = (
        <Typography className={classes.emptyContent}>
          <FormattedMessage id="emptyTicketTypes" />
        </Typography>
      );
    } else {
      const couponTicketsLeft =
        coupon && coupon.maxTicketsByCoupon ? coupon.maxTicketsByCoupon - ticketsCount : null;
      child = (
        <form className={classes.form} onSubmit={handleSubmit}>
          <div className={classes.tickets}>
            <Typography type="title" paragraph style={{ ...colors.title, ...section.styles.title }}>
              {section.data.title}
            </Typography>
            <CouponContainer
              ticketTypes={ticketTypes}
              eventId={event.id}
              registerShowCouponField={event.registerShowCouponField}
            />
            {ticketTypes
              .slice(0)
              .map(this.ticketBenefitMapper)
              .sort(this.compareByCouponAndDate)
              .map(ticketType => (
                <PreOrderItem
                  key={ticketType.id}
                  ticketType={ticketType}
                  couponTicketsLeft={couponTicketsLeft}
                />
              ))}
          </div>
          <OrderSummary
            event={event}
            site={site}
            section={section}
            ticketsCount={ticketsCount}
            subtotalValue={subtotalValue}
            totalValue={totalValue}
            submitting={submitting}
          />
        </form>
      );
    }

    return (
      <Section site={site} section={section} rootClassName={classes.root} className={classes.root}>
        {child}
      </Section>
    );
  }
}

const stylesheet = theme => ({
  root: {
    height: '100%',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: `calc(100vh - ${12 * theme.spacing.unit}px)`,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100%',
    },
  },
  tickets: {
    flex: '1 1 auto',
    padding: theme.spacing.large,
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.small,
    },
  },
  emptyContent: {
    padding: 8 * theme.spacing.unit,
  },
});

const orderFormSelector = formValueSelector('preOrder');
function mapStateToProps(state, ownProps) {
  const tickets = orderFormSelector(state, 'tickets');
  return {
    onChange: () => ownProps.preOrderChanged(tickets, mapBy(ownProps.ticketTypes, 'id')),
  };
}

export default compose(
  injectSheet(stylesheet),
  connect(mapStateToProps),
  reduxForm({ form: 'preOrder' }),
)(PreOrderForm);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/PreOrderForm/PreOrderForm.js